/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialFilterViewModel } from "../types/CourseFinancialFilterViewModel.ts";

export const courseFinancialFilterViewModelSchema = z.object({
  search: z
    .string()
    .describe("Texto livre aplicado à descrição do plano. Opcional.")
    .nullish(),
  active: z
    .boolean()
    .describe(
      "Filtra por situação do plano. Quando omitido, retorna ativos e inativos. No legado esse filtro era aplicado apenas no grid.",
    )
    .nullish(),
  pageNumber: z.optional(
    z.number().int().default(1).describe("Página da listagem. Mínimo 1."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  ),
}) as unknown as ToZod<CourseFinancialFilterViewModel>;
